// extracted by mini-css-extract-plugin
export default {"modalFooter":"jqMVO0QG2qTeckqZEIxQ"};